

























import { Component, Vue } from "vue-property-decorator";
import candleStore from "@/store/modules/candle";
import { debounce } from "throttle-debounce";

import CreateCandle from "./components/CreateCandle.vue";
import CandleInfo from "./components/CandleInfo.vue";
import CandleList from "./components/CandleList.vue";
import Candle from "./models/candle";
import AboutView from "./components/AboutView.vue";

@Component({
  components: {
    CreateCandle,
    CandleInfo,
    CandleList,
    AboutView,
  },
})
export default class App extends Vue {
  // eslint-disable-next-line
  private _scrollListener?: any;
  private _lightingNewCandle = false;

  private scrollOpacity = 100;
  private isAboutOpen = false;

  // MARK: Accessors
  get candle() {
    return candleStore.newCandle;
  }

  get candles() {
    return candleStore.candles;
  }

  get allCandlesLoaded() {
    return candleStore.allCandlesLoaded;
  }

  async lightNewCandle(newCandle: Candle) {
    this.$gtag.event("light-candle", { method: "Google" });

    await candleStore.createCandle(newCandle);

    if (candleStore.newCandleError) {
      const { message = "" } = candleStore.newCandleError;
      setTimeout(() => {
        this.$modal.show("dialog", {
          title: "Failed To Light Candle",
          text: message,
          buttons: [
            {
              title: "Close",
              handler: () => {
                this.$modal.hide("dialog");
              },
            },
          ],
        });
      }, 1200);
    }
  }

  handleLightNewCandleActive(active: boolean) {
    this._lightingNewCandle = active;

    if (this._lightingNewCandle) {
      this.$gtag.event("start-light-candle", { method: "Google" });
    }

    this.updateScrollOpacity();
  }

  // MARK: Lifecycle
  mounted() {
    candleStore.loadCandles();

    const scrollDebounceTime = 10; // 10ms

    this._scrollListener = debounce(scrollDebounceTime, false, () => {
      this.updateScrollOpacity();

      if (!this.allCandlesLoaded) {
        this.checkForLoadingMoreCandles();
      }
    });

    this.$el.addEventListener("scroll", this._scrollListener);
  }

  beforeDestroy() {
    this.$el.removeEventListener("scroll", this._scrollListener);
  }

  updateScrollOpacity() {
    const screenY = screen.height;
    const startFadeY = screenY * (this._lightingNewCandle ? 0.35 : 0.25); // Start fading after scrolled this percent

    const currentScroll = this.$el.scrollTop;

    let opacity;

    // Only update opacity if a candle is not set.
    if (this.candle || currentScroll < startFadeY) {
      opacity = 1;
    } else {
      const effectiveScroll = currentScroll - startFadeY;
      const checkpoint = screenY * 0.15; // Scroll 30% of the screen from startFade to reach full fade.

      opacity = Math.max(0, 1 - effectiveScroll / checkpoint);
    }

    this.scrollOpacity = opacity;
  }

  checkForLoadingMoreCandles() {
    const getScrollValue = () => {
      const h = document.documentElement;
      const b = this.$el;

      return (
        (h.scrollTop || b.scrollTop) /
        ((b.scrollHeight || h.scrollHeight) - h.clientHeight)
      );
    };

    const percentScrolled = getScrollValue();

    if (percentScrolled > 0.9) {
      const screenY = screen.height;
      const currentScroll = this.$el.scrollTop;
      const scrolled = currentScroll / screenY;

      // Only load the second page forward
      if (scrolled > 1) {
        candleStore.loadNextPage();
        this.$gtag.event("scrolled-candles", { method: "Google" });
      }
    }
  }

  clickAbout() {
    if (!this.isAboutOpen) {
      this.$modal.show("about", {
        height: "auto",
      });
    } else {
      this.$modal.hide("about");
    }
  }

  onAboutOpened() {
    this.isAboutOpen = true;
    this.$gtag.event("open-about", { method: "Google" });
  }

  onAboutClosed() {
    this.isAboutOpen = false;
  }
}
